module.exports = __webpack_public_path__ + "media/images/lp/industries/realestate/tokyu-housing-leace-992aa511e5eae2f98aa95ec862a6a2d0.png";